var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 2H6V0H4V2ZM8 2V0H10V2H8ZM4 10V8H6V10H4ZM12 6V4H14V6H12ZM12 10V8H14V10H12ZM8 10V8H10V10H8ZM12 2V0H14V2H12ZM6 4V2H8V4H6ZM0 16V0H2V2H4V4H2V6H4V8H2V16H0ZM10 8V6H12V8H10ZM6 8V6H8V8H6ZM4 6V4H6V6H4ZM8 6V4H10V6H8ZM10 4V2H12V4H10Z",
    fill: "#767A85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.e8232e27fcc9d36f2ae172b23091c8b4.svg";
export { ForwardRef as ReactComponent };